// Signin
export const GET_TEAM_MEMBERS = 'teamActions/GET_TEAM_MEMBERS';
export const GET_TEAM_MEMBERS_SUCCESS = 'teamActions/GET_TEAM_MEMBERS_SUCCESS';
export const GET_TEAM_MEMBERS_FAILED = 'teamActions/GET_TEAM_MEMBERS_FAILURE';

export const GET_STAFF = 'teamActions/GET_STAFF';
export const GET_STAFF_SUCCESS = 'teamActions/GET_STAFF_SUCCESS';
export const GET_STAFF_FAILED = 'teamActions/GET_STAFF_FAILURE';

export const CREATE_TEAM = 'teamActions/CREATE_TEAM';
export const CREATE_TEAM_SUCCESS = 'teamActions/CREATE_TEAM_SUCCESS';
export const CREATE_TEAM_FAILED = 'teamActions/CREATE_TEAM_FAILURE';

export const UPDATE_TEAM = 'teamActions/UPDATE_TEAM';
export const UPDATE_TEAM_SUCCESS = 'teamActions/UPDATE_TEAM_SUCCESS';
export const UPDATE_TEAM_FAILED = 'teamActions/UPDATE_TEAM_FAILURE';

export const SWITCH_ORDER = 'teamActions/SWITCH_ORDER';
export const UPDATE_STATUS = 'teamActions/UPDATE_STATUS';

export function createUpdateTeam(id, details, filter) {
  return {
    type: CREATE_TEAM,
    details,
    id,
    filter,
  };
}

export function createTeamSuccess(id, team) {
  return {
    type: CREATE_TEAM_SUCCESS,
    team,
    id,
  };
}

export function createTeamFailed(err, id) {
  return {
    type: CREATE_TEAM_FAILED,
    err,
    id,
  };
}

export function updateTeam(details) {
  return {
    type: UPDATE_TEAM,
    details,
  };
}

export function updateTeamSuccess(user) {
  return {
    type: UPDATE_TEAM_SUCCESS,
    user,
  };
}

export function updateTeamFailed(err) {
  return {
    type: UPDATE_TEAM_FAILED,
    err,
  };
}

export function getTeamMembers(filter, pageFolderId) {
  return {
    type: GET_TEAM_MEMBERS,
    filter,
    pageFolderId,
  };
}

export function getTeamMembersSuccess(teams) {
  return {
    type: GET_TEAM_MEMBERS_SUCCESS,
    teams,
  };
}

export function getTeamMembersFailed(err) {
  return {
    type: GET_TEAM_MEMBERS_FAILED,
    err,
  };
}

export function getStaff(filter, pageFolderId) {
  return {
    type: GET_STAFF,
    filter,
    pageFolderId,
  };
}

export function getStaffSuccess(teams) {
  return {
    type: GET_STAFF_SUCCESS,
    teams,
  };
}

export function getStaffFailed(err) {
  return {
    type: GET_STAFF_FAILED,
    err,
  };
}

export function switchOrder(users) {
  return {
    type: SWITCH_ORDER,
    users,
  };
}

export function updateStatus() {
  return {
    type: UPDATE_STATUS,
  };
}
